export const WORKSPACE_ORG_ADMIN = 'workspace_org_admin';
export const ACCOUNT_MANAGEMENT_LE_ADMIN = 'account_management/legal_entity:admin';
